<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs margin-bottom-30">
                        <h3 class="">
                            <img src="static/images/icones/engineering.png" style="height: 50px">
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">

                        <div class="col-lg-12 margin-bottom-15" v-if="$root.user.tipo == 'admin'">
                            <router-link :to="{'name': 'CadastrarFormularios'}" class="button block-mobile transparent">
                                <i class="las la-plus"></i>
                                Adicionar novo formulário
                            </router-link>
                        </div>                               
                        <div class="col-xl-12">
                            <form v-show="mostrarFiltro" method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get" novalidate>
                                <div class="row right-xs">

                                    <div class="hidden-xl hidden-lg hidden-md col-xs-12" style="text-align: right;">
                                        <button type="button" v-on:click="mostrarFiltro = false;" class="button small gray margin-bottom-20">
                                            <i class="las la-angle-up"></i>
                                            Esconder filtros
                                        </button>      
                                    </div>

                                    <div class="col-lg-4 col-xs-6 col-xl-4 col-md-5">
                                        <div class="submit-field">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>           
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-6">
                                        <div class="submit-field">
                                            <h5>Área:</h5>
                                            <select class="with-border" v-model="form.areaCod">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in areas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select>
                                        </div>
                                    </div>                                                                                                 
                                    <div class="col-lg-2 col-md-2 col-xs-4 hidden-xs hidden-md">
                                        <div class="submit-field">
                                            <!-- <div class="hidden-xs clearfix" style="margin-top: 21px;"></div> -->
                                            <button class="button small green" style="height: 40px;">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button>                                                                              
                                        </div>
                                    </div>
                                    <div class="col-xs-7 margin-bottom-20  col-md-7">
                                        <div class=" padding-top-12"></div>
                                        <small style="display: block; line-height: 130%"><b>{{data.total}}</b> resultado(s) encontrado(s).</small>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-xs-5 hidden-xl hidden-lg" style="text-align: right;">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg margin-top-10"></div>
                                            <div class="hidden-xs hidden-md clearfix" style="margin-top: 32px;"></div>
                                            <button class="button small green block-mobile">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button> 

                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl hidden-lg margin-top-20"></div>
                            </form> 
                        </div>
                        <div class="col-xl-12">

                            <button v-if="mostrarFiltro" type="button" v-on:click="mostrarFiltro = false;" class="button small gray margin-bottom-20" style="height: 40px;">
                                <i class="las la-angle-up"></i>
                                Esconder filtros
                            </button>     

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-lg hidden-md hidden-xl button small gray margin-bottom-20 float-right">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>

                            <button v-if="!mostrarFiltro" type="button" v-on:click="importar()" class="hidden-lg hidden-md hidden-xl button small color-gray margin-right-10 margin-bottom-20 float-right">
                                <i class="las la-upload"></i>
                                Importar
                            </button>                            

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-xs button small gray margin-bottom-20">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>

                            <button type="button" v-on:click="importar()" class="hidden-xs button small color-gray margin-bottom-20">
                                <i class="las la-upload"></i>
                                Importar
                            </button>                            


                            <div class="clearfix"></div>

                            <h5 v-show="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>
                                Nenhum resultado encontrado.
                            </h5>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 50px; width: 50px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Áreas
                                        </th>                                        
                                        <th style="min-width: 90px; width: 90px; text-align: center;">
                                            Etapas
                                        </th>                                                                                                           
                                        <th style="min-width: 120px; width: 120px;">
                                            Última atualização
                                        </th>     
                                        <th style="min-width: 120px; width: 120px;">
                                            Criado em
                                        </th>     
                                        <th style="min-width: 180px; width: 180px;">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.itens" v-bind:class="{'opacidade': item.ativo == 0}">
                                            <td data-label="">
                                                <router-link :to="{'name': 'EditarFormularios', 'query': {'c': item.cod}}">
                                                    <span class="hidden-xl hidden-lg">ID: </span>{{item.id}}
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': 'EditarFormularios', 'query': {'c': item.cod}}">
                                                    <u style="font-weight: 600">{{item.nome}}</u>
                                                </router-link>
                                                <small class="block margin-top-5"><i class="las la-user"></i> Criado por: {{item.criadoPor.nome}}</small>
                                                <span class="dashboard-status-button color-orange" style="top: 5px; margin-bottom: 10px;" v-if="item.ativo == 0">
                                                    <i class="las la-pause-circle"></i> Desativado
                                                </span>
                                            </td>
                                            <td data-label="Áreas">
                                                <span v-for="(item2, index2) in item.areas">{{item2.nome}}{{index2 == (item.areas.length-1) ? '' : ', '}}</span>
                                            </td>                                             
                                            <td data-label="Etapas" style="text-align: center;">
                                                {{item.etapas.length}}
                                            </td>                     
                                            <td data-label="Última atualização">
                                                {{item.atualizacao | formatDate}}
                                            </td>  
                                            <td data-label="Criado em">
                                                {{item.datahora | formatDate}}
                                            </td>   
                                            <td>
                                                <router-link :to="{'name': 'EditarFormularios', 'query': {'c': item.cod}}" class="dashboard-status-button gray">
                                                    <i class="las la-edit"></i>
                                                    Editar
                                                </router-link>
                                                <!-- <div class="hidden-xs hidden-md" style="height: 5px;"></div> -->
                                                <a class="dashboard-status-button gray" v-on:click="del(item.cod)">
                                                    <i class="las la-trash"></i>
                                                    Apagar
                                                </a>                                                                                      
                                            </td>                                                                                                                                       
                                        </tr>

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="las la-arrow-left"></i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="las la-arrow-right"></i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>                                
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Formularios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "mostrarFiltro":        false,
            "loaded":               false,
            "areas":                 {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "",
                "areaCod":          "",
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        importar: function() {
            var self        = this;
            alert("Em desenvolvimento!");
        },
        getAreas: function() {
            var self        = this;
            console.log("getAreas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                    }
                };

                axios.get("api/areas.php", form)
                .then(response => {
                    
                    console.log("getAreas() response", response);
                    self.areas          = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getAreas() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },        
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }

                axios.get("api/formularios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/formularios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        self.get();
        self.getAreas();
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .opacidade {
        opacity: 0.5 !important;
    }

    span i {
        color: inherit !important;
        top: 1px !important;
    }

    @media only screen and (max-width: 500px) { 

        .table-responsive td {
            text-align: left !important;
        }

    }    
</style>



// WEBPACK FOOTER //
// src/components/Formularios.vue